function pathWithParams(path, queryParams) {
  if (queryParams && Object.keys(queryParams).length !== 0) {
    return `${path}?${new URLSearchParams(queryParams).toString()}`
  } else {
    return path
  }
}

const Routes = {
  // Auth
  logoutPath: () => (
    `/auth/logout`
  ),
  // Exports
  exportCapitalGrowthPath: ({ clientId }, { queryParams } = {}) => pathWithParams(
    `/clients/${clientId}/exports/capital_growth`,
    queryParams
  ),
  // Help
  helpPath: () =>
    "https://help.wealthbit.co/",

  // PDF
  downloadScenarioPDFPath: ({ clientId }, { queryParams } = {}) => pathWithParams(
    `/generate_client_report/${clientId}/client_report.pdf`,
    queryParams
  ),
  downloadJointPlanPDFPath: ({ clientId }, { queryParams } = {}) => pathWithParams(
    `/generate_joint_plan_report/${clientId}/client_report.pdf`,
    queryParams
  ),

  // Communication
  notifyCompliancePath: ({ clientId }) => pathWithParams(
    `/notify_compliance/${clientId}`
  ),
  astuteRequestsPath: ({ clientId }) => (
    `/wealth_managers/clients/${clientId}/astute_requests`
  ),
  requestWealthManagerPath: ({ clientId }) => (
    `/clients/${clientId}/wealth_manager_requests`
  ),
  requestOtpPath: ({ clientId }) => (
    `/clients/${clientId}/onboarding/risk_profile_consent_otp.js`
  ),
  verifyOtpPath: ({ clientId }) => (
    `/clients/${clientId}/onboarding/verify_otp.js`
  ),
  resendOtpPath: ({ clientId }) => (
    `/clients/${clientId}/onboarding/risk_profile_resend_consent_otp.js`
  ),
  sendLoginLinkPath: ({ clientId }) => (
    `/clients/${clientId}/send_login_link`
  ),

  // Scenario
  createScenarioPath: () => (
    `/api/scenarios`
  ),
  setSessionTimeValuePath: ({ clientId, timeValue }) => (
    `/clients/${clientId}/scenarios/toggle_time_value_view/${timeValue}`
  ),
  showScenarioReportPath: ({ clientId, scenarioId }) => (
    `/clients/${clientId}/scenarios/${scenarioId}/report`
  ),

  // Joint Plan
  jointPlansPath: ({ clientId }) => (
    `/clients/${clientId}/joint_plans`
  ),
  jointScenarioPath: ({ clientId, jointScenarioId }) => (
    `/clients/${clientId}/joint_scenarios/${jointScenarioId || ''}`
  ),
  newJointScenarioPath: ({ clientId }) => (
    `/clients/${clientId}/joint_scenarios/new`
  ),

  // Referrals
  referralsPath: ({ clientId }) => (
    `/clients/${clientId}/referrals`
  ),

  // Organization
  organizationDashboardPath: () => (
    `/organization_dashboard`
  ),

  // FSP Admin
  fspAdminDashboardPath: () => (
    `/fsp-admin`
  ),
  apiFspAdminWealthManagersPath: () => (
    `/api/fsp-admin/wealth-managers`
  ),
  apiFspAdminParaplannersPath: () => (
    `/api/fsp-admin/paraplanners`
  ),
  apiFspAdminParaplannerAssignmentsPath: () => (
    `/api/fsp-admin/paraplanner-assignments`
  ),
  apiFspAdminClientsPath: () => (
    `/api/fsp-admin/clients`
  ),
  apiFspAdminClientsIdsPath: () => (
    `/api/fsp-admin/clients/ids`
  ),
  apiFspAdminClientsExportPath: () => (
    `/api/fsp-admin/clients/export`
  ),
  apiFspAdminClientTransfersBulkCreatePath: () => (
    `/api/fsp-admin/client-transfers/bulk-create`
  ),

  // Clients
  clientsPath: () => (
    `/clients`
  ),
  editClientPath: ({ clientId }) => (
    `/clients/${clientId}/edit`
  ),
  clientProfilePath: ({ clientId }) => (
    `/clients/${clientId}/profile`
  ),
  clientDashboardPath({ clientId }) {
    return `/clients/${clientId}/scenarios/dashboard`
  },
  clientScenarioPath({ clientId, scenarioId }) {
    return `/clients/${clientId}/scenarios/${scenarioId}`
  },
  clientScenariosPath({ clientId }) {
    return `/clients/${clientId}/scenarios`
  },

  // WealthManagers
  wealthManagerDashboardPath: ({ wealthManagerId }) => (
    `/wealth_managers/${wealthManagerId}/dashboard`
  ),

  // Reminders
  remindersPath: ({ wealthManagerId }) => (
    `/wealth_managers/${wealthManagerId}/notices`
  ),

  // Task
  tasksPath: ({ wealthManagerId }) => (
    `/wealth_managers/${wealthManagerId}/tasks`
  ),

  // Propspects
  prospectsPath: () => (
    `/prospects`
  ),
  archivedProspectsPath: () => (
    `/prospects/archived`
  ),

  // Paraplanners
  paraplannersPath: () => (
    `/paraplanners`
  ),

  // Settings
  settingsPath: ({ wealthManagerId }) => (
    `/wealth_managers/${wealthManagerId}/preferences`
  ),

  // User Profiles
  userProfileDashboardPath: () => (
    `/user_dashboard`
  ),

  // Astute
  astuteRefreshPath: ({ clientId, astuteRequestId }) => (
    `/wealth_managers/clients/${clientId}/astute_requests/${astuteRequestId}/refresh`
  ),
  downloadAstuteReportPDFPath: ({ clientId, astuteRequestId }) => (
    `/wealth_managers/clients/${clientId}/astute_requests/${astuteRequestId}.pdf`
  ),

}

export default Routes
